import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { IMaintenanceModeContext } from '../../../../model/maintenance';
import { LocationContextService } from '../../../app/location-context/location-context.service';
import { MaintenanceService } from '../../../app/maintenance/maintenance.service';

// NOTE: not used
// This component is still referenced in other components but is inactive for now

@Component({
    selector: 'app-maintenance-mode-alert',
    templateUrl: './maintenance-mode-alert.component.html',
    styleUrls: ['./maintenance-mode-alert.component.scss']
})
export class MaintenanceModeAlertComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    inMaintenanceMode: boolean;
    maintenanceModeContext$: Observable<IMaintenanceModeContext>;

    constructor(
        private readonly maintenanceService: MaintenanceService,
        private readonly locationContextService: LocationContextService
    ) {}

    ngOnInit() {
        // Get location context
        const locationContext = this.locationContextService.getLocationContext();

        // Request data
        this.maintenanceService.requestMaintenanceModeContext(locationContext);

        // Load data
        this.maintenanceModeContext$ = this.maintenanceService.getMaintenanceModeContext();

        // Subscribe
        this.sub = this.maintenanceModeContext$.subscribe(maintenanceModeContext => {
            this.inMaintenanceMode = maintenanceModeContext.inMaintenanceMode;
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
